import type { PreflightMarket } from "../types/preflight.types";

/** Join-ordered display names. Empty joins use the same placeholder the list/detail use. */
export function reportMarketsLabel(
  markets: readonly PreflightMarket[],
  noneLabel: string,
): string {
  if (markets.length === 0) return noneLabel;
  return markets.map((market) => market.name).join(", ");
}
